import { RoomInfo } from 'shared/types/app-types';

export interface GamesStoreState {
  /**
   * List of active rooms where players are currently playing.
   * These rooms have at least one opponent and are not closed.
   */
  activeRooms: RoomInfo[];
  /**
   * List of rooms that have been played (closed).
   * These rooms have at least one opponent and are closed.
   */
  playedRooms: RoomInfo[];
  /**
   * List of active rooms where players are playing alone (no opponent).
   * These rooms are not closed.
   */
  activeSingle: RoomInfo[];
  /**
   * List of played rooms (closed) that were fetched in the first batch.
   */
  playedRoomsFirstBatch: RoomInfo[];
  /**
   * Counter for the total number of rooms created.
   * This is fetched from the blockchain.
   */
  roomIdCounter: number;
  /**
   * Counter for the total number of active rooms.
   * This is fetched from the blockchain.
   */
  activeRoomCounter: number;
  /**
   * Timestamp of the last time the rooms were fetched.
   */
  lastFetched: number;
  /**
   * Indicates whether the store is currently loading data.
   */
  loading: boolean;
  /**
   * Interval ID for the periodic fetching of rooms.
   * This is used to clear the interval when the store is cleared or updated.
   */
  intervalId: NodeJS.Timeout | null;
  /**
   * The last time the block number was fetched.
   * This is used to determine when to fetch new room events.
   */
  time: number;
}

export enum GamesFetchMode {
  FULL = 'full',
  QUICK = 'quick',
}

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
  DEFAULT = 'default',
}

export enum CurrencyFilter {
  ALL = 'all',
}
